import classNames from "classnames";
import React, { useContext } from "react";
import { RicosContext } from "./../../ricos-context";
import { EXPAND_BUTTON } from "../data-hooks";
import { ArrowIcon } from "../icons";
import styles from "../statics/styles/collapsible-list-component.rtlignore-scss";
const ExpandCollapseButton = (props) => {
  const { tabIndex } = useContext(RicosContext);
  const { onClick, ariaLabel } = props;
  return (
    //using 'div' element instead of 'button' to fix a bug of focus on element in Firefox in OSX
    // further reading, https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button#Clicking_and_focus#Clicking_and_focus
    /* @__PURE__ */ React.createElement(
      "div",
      {
        role: "button",
        tabIndex: -1,
        className: styles.iconContainer,
        onClick,
        onKeyUp: (e) => (e.key === " " || e.key === "Enter") && onClick(e),
        "data-hook": EXPAND_BUTTON
      },
      /* @__PURE__ */ React.createElement(
        ArrowIcon,
        {
          role: "button",
          tabIndex,
          "aria-label": ariaLabel,
          className: classNames(styles.icon, props.isExpanded && styles.isExpanded)
        }
      )
    )
  );
};
var ExpandCollapseButton_default = ExpandCollapseButton;
export {
  ExpandCollapseButton_default as default
};
//# sourceMappingURL=ExpandCollapseButton.js.map
